import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserDetails } from '../utilities/backendTypes';
import { copyTo } from '../utilities/functions';
import userService from '../service/userService';

const defaultUserDetails: UserDetails = {
  id: -1,
  name: 'Default User',
  detailsLoaded: false,
  lastLogin: new Date().toISOString(),
} as const;

export interface UserState {
  currentUserId?: number;
  all: UserDetails[];
  token?: string;
  tokenLoaded: boolean;
  emailSent: boolean;
  message?: string;
  newUser?: UserDetails;
  updatedUser?: UserDetails;
}

export const initialState: UserState = {
  all: [] as UserDetails[],
  token: '',
  emailSent: false,
  tokenLoaded: false,
} as const;

export const listUsers = createAsyncThunk('listUsers', userService.listUsers);

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
      localStorage.setItem('token', state.token);
      state.tokenLoaded = true;
    },
    loadToken(state) {
      const token = localStorage.getItem('token');
      if (token) {
        state.token = token;
      }
      state.tokenLoaded = true;
    },
    logout() {
      localStorage.removeItem('token');
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listUsers.pending, (state, action) => {})
      .addCase(listUsers.fulfilled, (state, action) => {
        state.all = action.payload.map((u, i) => copyTo(u, defaultUserDetails));
      })
      .addCase(listUsers.rejected, (state, action) => {
        state.message = action.error.message;
        state.all = [];
      });
  },
});

export const { setToken, loadToken, logout } = userSlice.actions;
export default userSlice.reducer;
